import { render } from "./Blank.vue?vue&type=template&id=5aacde5c&scoped=true"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import "./Blank.vue?vue&type=style&index=0&id=5aacde5c&scoped=true&lang=scss"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aacde5c"]])

export default __exports__